import { ErrorHandler, inject, Injectable, InjectionToken } from '@angular/core';

import { isChunkLoadError } from './chunk-load-error.util';

const CHUNK_ERROR_KEY = 'CHUNK_ERROR_RELOAD';
const COOLDOWN_MS = 30_000;

/** provideVersionCheck() занимает корневой ErrorHandler — не-chunk ошибки идут в этот токен, а не соревнуются за provide. */
export const CHUNK_ERROR_FALLBACK_HANDLER = new InjectionToken<ErrorHandler>('CHUNK_ERROR_FALLBACK_HANDLER');

@Injectable()
export class ChunkErrorHandler extends ErrorHandler {
  private readonly fallback = inject(CHUNK_ERROR_FALLBACK_HANDLER, { optional: true });

  override handleError(error: unknown): void {
    if (isChunkLoadError(error) && this.canReload()) {
      sessionStorage.setItem(CHUNK_ERROR_KEY, Date.now().toString());
      this.reloadPage();

      return;
    }

    if (this.fallback) {
      this.fallback.handleError(error);

      return;
    }

    super.handleError(error);
  }

  /** Шов для тестов: jsdom не даёт застабить window.location.reload напрямую. */
  protected reloadPage(): void {
    window.location.reload();
  }

  private canReload(): boolean {
    const lastReload = sessionStorage.getItem(CHUNK_ERROR_KEY);

    if (!lastReload) return true;

    return Date.now() - Number(lastReload) > COOLDOWN_MS;
  }
}
